module.exports = __webpack_public_path__ + "static/img/ubg7.d107dcfc.png";